<template>
  <div
    class="asc-event-report-grid-wrapper--container"
    data-automation-id="wrapper_event_report_grid"
  >
    <asc-accordion :value="accordionClosed" flat>
      <asc-accordion-item @change="onAccordionChange()">
        <template slot="header">
          <asc-surface-title
            class="event-report-surface-title"
            :title="title"
          />
        </template>

        <asc-surface-support-text :text="infoMessage" />
        <div
          v-if="filterFields"
          :class="[
            'asc-event-report-grid-wrapper--filters',
            loading ? 'asc-event-report-grid-wrapper--filters-disabled' : null,
          ]"
          :style="{ width: '14rem' }"
        >
          <asc-date-picker
            :id="filterFields.id"
            v-model="filterFields.selection"
            :label="filterFields.label"
            :max-days="filterFields.maxDays"
            :show-fixed-options="filterFields.showFixedOptions"
            :hide-options-with-id="filterFields.hideOptionsWithId"
            :has-icon="filterFields.dropDown ? true : false"
            :drop-down="filterFields.dropDown"
            auto-re-position
            hide-details
          />
        </div>
        <asc-event-report-grid
          :values="values"
          :on-open="onOpen"
          :on-open-report-summary="onOpenReportSummary"
          :grid-filters="gridFilters"
          :is-grid-data-loaded="isGridDataLoaded"
          :grid-columns="gridColumns"
        />
      </asc-accordion-item>
    </asc-accordion>
  </div>
</template>

<script>
import { AscGridPropsMixin, AscRangeDatePickerMixin } from '@/components/mixins'
import AscAccordion from '@/components/atoms/AscAccordion'
import AscAccordionItem from '@/components/atoms/AscAccordionItem'
import AscEventReportGrid from '@/components/molecules/AscEventReportGrid'
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'
import AscSurfaceSupportText from '@/components/atoms/AscSurfaceSupportText'
import AscDatePicker from '@/components/atoms/AscDatePicker'

export default {
  name: 'AscEventReportGridWrapper',

  components: {
    AscDatePicker,
    AscEventReportGrid,
    AscAccordion,
    AscAccordionItem,
    AscSurfaceTitle,
    AscSurfaceSupportText,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],

  props: {
    eventReportFilterFields: {
      type: Array,
      default: () => [],
    },
    onOpenReportSummary: {
      type: Function,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    gridColumns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      accordionClosed: 0,
      infoMessage: `See event reports for my fleet.`,
    }
  },

  computed: {
    filterFields() {
      return this.eventReportFilterFields[0]
    },
  },

  watch: {
    filterFields: {
      deep: true,
      handler(val, oldVal) {
        if (oldVal !== undefined) {
          this.$emit('onFiltersChange', this.eventReportFilterFields)
        }
      },
    },
  },

  created() {
    this.accordionClosed = this.getAccordionStatus()
  },

  methods: {
    onAccordionChange() {
      this.accordionClosed = this.accordionClosed ? 0 : 1
      window.localStorage.setItem('event_reports_options', this.accordionClosed)
    },
    getAccordionStatus() {
      return window.localStorage.getItem('event_reports_options') === '1'
        ? 1
        : 0
    },
  },
}
</script>

<style lang="scss">
.asc-event-report-grid-wrapper--container {
  margin-bottom: 16px;

  .asc-event-report-grid-wrapper--filters {
    margin-bottom: 22.19px;
    width: 175px;

    &-disabled {
      cursor: not-allowed;

      .asc-filters {
        position: relative;

        &::after {
          content: '';
          background: transparent;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
        }
      }
    }
  }

  .event-report-surface-title {
    padding-top: 16px;
  }
}
</style>
